export const BLOCK_CONTENT_ATTRIBUTE = "data-axure-block-content";
